(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["smx-careers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smx-careers')) {
  customElements.define('smx-careers', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.department = this.querySelector('[data-careers-department]');
      this.location = this.querySelector('[data-careers-location]');
      this.jobs = Array.from(this.querySelectorAll('[data-careers-job]'));
      this.count = this.querySelector('[data-careers-count]');
      this.empty = this.querySelector('[data-careers-empty]');
      const filters = this.querySelector('[data-careers-filters]');
      if (filters) filters.hidden = false;
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-careers-department], [data-careers-location]')) this.filter();
      }, options);
      this.querySelector('[data-careers-reset]')?.addEventListener('click', () => this.reset(), options);
      this.addEventListener('shopify:block:select', () => this.reset(), options);
      this.filter();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    reset() {
      if (this.department) this.department.value = '';
      if (this.location) this.location.value = '';
      this.filter();
    }
    filter() {
      const department = this.department?.value || '';
      const location = this.location?.value || '';
      let count = 0;
      this.jobs.forEach((job) => {
        const visible = (!department || job.dataset.department === department) && (!location || job.dataset.location === location);
        job.hidden = !visible;
        if (visible) count += 1;
      });
      this.count.textContent = `${count} ${count === 1 ? this.dataset.countSingular : this.dataset.countPlural}`;
      this.empty.hidden = count > 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smx-design-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smx-hero-slideshow')) {
  customElements.define('smx-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      if (this.slides.length < 2) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.index = 0;
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = true;
      this.desktop = window.matchMedia('(min-width: 768px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.designMode = this.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
      this.delay = Math.min(12, Math.max(5, Number(this.dataset.interval) || 7)) * 1000;
      this.controls = this.querySelector('[data-hero-controls]');
      this.toggleButton = this.querySelector('[data-hero-toggle]');
      this.counter = this.querySelector('[data-hero-current]');
      this.status = this.querySelector('[data-hero-status]');
      this.controls.hidden = false;
      this.querySelector('[data-hero-previous]').addEventListener('click', () => this.show(this.index - 1, true), { signal });
      this.querySelector('[data-hero-next]').addEventListener('click', () => this.show(this.index + 1, true), { signal });
      this.toggleButton.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.schedule();
      }, { signal });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.schedule();
      }, { signal });
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.schedule();
      }, { signal });
      this.addEventListener('focusin', () => {
        this.focused = true;
        this.schedule();
      }, { signal });
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }, { signal });
      this.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
        this.pointerStart = { x: event.clientX, y: event.clientY };
        this.setPointerCapture(event.pointerId);
      }, { signal, passive: true });
      this.addEventListener('pointerup', event => {
        if (!this.pointerStart) return;
        const dx = event.clientX - this.pointerStart.x;
        const dy = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) this.show(this.index + (dx < 0 ? 1 : -1), true);
      }, { signal, passive: true });
      this.addEventListener('pointercancel', () => { this.pointerStart = null; }, { signal });
      this.desktop.addEventListener('change', () => this.schedule(), { signal });
      this.reducedMotion.addEventListener('change', () => this.schedule(), { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId !== this.dataset.sectionId) return;
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index, true);
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.1 });
      this.observer.observe(this);
      this.show(0);
      this.schedule();
    }

    show(index, manual = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
      });
      this.counter.textContent = String(this.index + 1);
      if (manual) {
        this.userPaused = true;
        this.status.textContent = this.dataset.statusTemplate.replace('{index}', String(this.index + 1));
        this.schedule();
      }
    }

    schedule() {
      window.clearTimeout(this.timer);
      const autoplayAvailable = this.autoplayEnabled && this.desktop.matches && !this.reducedMotion.matches && !this.designMode;
      this.toggleButton.hidden = !autoplayAvailable;
      this.toggleButton.setAttribute('aria-label', this.userPaused ? this.toggleButton.dataset.playLabel : this.toggleButton.dataset.pauseLabel);
      this.querySelector('[data-hero-pause-icon]').hidden = this.userPaused;
      this.querySelector('[data-hero-play-icon]').hidden = !this.userPaused;
      if (!autoplayAvailable || this.userPaused || this.hovered || this.focused || !this.visible || document.hidden) return;
      this.timer = window.setTimeout(() => {
        this.show(this.index + 1);
        this.schedule();
      }, this.delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.observer?.disconnect();
      this.events?.abort();
      this.events = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smx-instagram-visual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smx-instagram-visual')) {
  customElements.define('smx-instagram-visual', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

      this.events = new AbortController();
      const { signal } = this.events;
      this.setAttribute('data-ready', '');
      this.select(this.tabs[this.selectedIndex] ? this.selectedIndex : 0);

      this.addEventListener('click', event => {
        this.select(this.tabs.indexOf(event.target.closest('[role="tab"]')));
      }, { signal });

      this.addEventListener('keydown', event => {
        let index = this.tabs.indexOf(event.target.closest('[role="tab"]'));
        if (index < 0) return;
        if (event.key === 'ArrowRight') index++;
        else if (event.key === 'ArrowLeft') index--;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else return;
        event.preventDefault();
        index = (index + this.tabs.length) % this.tabs.length;
        this.select(index);
        this.tabs[index].focus();
      }, { signal });

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', event => {
          const block = event.target.closest('[data-block-index]');
          if (block && this.contains(block)) this.select(Number(block.dataset.blockIndex));
        }, { signal });
      }
    }

    disconnectedCallback() {
      this.events?.abort();
    }

    select(index) {
      if (!this.tabs[index] || !this.panels[index]) return;
      this.selectedIndex = index;
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('btn--primary', active);
        tab.classList.toggle('btn--secondary', !active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smx-location"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smx-location')) {
  const loadPlaces = (key, language) => {
    if (window.google?.maps?.importLibrary) return window.google.maps.importLibrary('places');
    if (!window.smxLocationPlacesPromise) {
      window.smxLocationPlacesPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timeout = setTimeout(() => reject(new Error('Google Maps timeout')), 15000);
        window.smxLocationPlacesReady = () => {
          clearTimeout(timeout);
          resolve(window.google.maps.importLibrary('places'));
        };
        script.onerror = () => { clearTimeout(timeout); reject(new Error('Google Maps unavailable')); };
        script.async = true;
        script.src = 'https://maps.googleapis.com/maps/api/js?' + new URLSearchParams({key, language, v: 'weekly', loading: 'async', callback: 'smxLocationPlacesReady', auth_referrer_policy: 'origin'});
        document.head.append(script);
      }).catch(error => { window.smxLocationPlacesPromise = null; throw error; });
    }
    return window.smxLocationPlacesPromise;
  };
  customElements.define('smx-location', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-location-load]');
      this.frame = this.querySelector('iframe');
      this.status = this.querySelector('[data-location-status]');
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.loadMap());
    }
    embedURL() {
      let raw = this.dataset.embed.trim();
      if (raw.includes('<iframe')) raw = new DOMParser().parseFromString(raw, 'text/html').querySelector('iframe')?.getAttribute('src') || '';
      const url = new URL(raw);
      if (url.protocol !== 'https:' || !['www.google.com', 'maps.google.com', 'www.google.de', 'maps.google.de'].includes(url.hostname) || !url.pathname.startsWith('/maps/embed')) throw new Error('Invalid Google Maps embed');
      return url.href;
    }
    loadMap() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.button.disabled = true;
      this.status.textContent = this.dataset.loadingLabel;
      try {
        const src = this.embedURL();
        const map = this.querySelector('[data-location-map]');
        map.style.minHeight = map.getBoundingClientRect().height + 'px';
        const timeout = setTimeout(() => this.mapError(), 20000);
        this.frame.addEventListener('load', () => {
          clearTimeout(timeout);
          this.loaded = true;
          this.loading = false;
          this.status.textContent = '';
          this.querySelector('[data-location-poster]').hidden = true;
          this.frame.hidden = false;
        }, {once: true});
        this.frame.addEventListener('error', () => { clearTimeout(timeout); this.mapError(); }, {once: true});
        this.frame.loading = 'eager';
        this.frame.src = src;
        if (this.dataset.apiKey && this.dataset.placeId) this.loadRating();
      } catch { this.mapError(); }
    }
    mapError() {
      if (this.loaded) return;
      this.loading = false;
      this.button.disabled = false;
      this.status.textContent = this.dataset.errorLabel;
    }
    async loadRating() {
      const status = this.querySelector('[data-location-rating-status]');
      try {
        const { Place } = await loadPlaces(this.dataset.apiKey, this.dataset.locale.split('-')[0]);
        const place = new Place({id: this.dataset.placeId});
        await place.fetchFields({fields: ['rating', 'userRatingCount']});
        if (!this.isConnected || !Number.isFinite(place.rating) || !Number.isFinite(place.userRatingCount)) throw new Error('Rating unavailable');
        const score = new Intl.NumberFormat(this.dataset.locale, {maximumFractionDigits: 1, minimumFractionDigits: 1}).format(place.rating);
        const count = new Intl.NumberFormat(this.dataset.locale).format(place.userRatingCount);
        const card = this.querySelector('[data-location-rating]');
        this.querySelector('[data-location-score]').textContent = score;
        this.querySelector('[data-location-count]').textContent = this.dataset.countLabel.replace('[count]', count);
        card.setAttribute('aria-label', this.dataset.ratingLabel.replace('[score]', score).replace('[count]', count));
        const attributions = this.querySelector('[data-location-attributions]');
        for (const source of place.attributions || []) {
          if (!source.provider) continue;
          const node = document.createElement(source.providerURI?.startsWith('https://') ? 'a' : 'span');
          node.textContent = source.provider;
          if (node.tagName === 'A') { node.href = source.providerURI; node.target = '_blank'; node.rel = 'noopener'; }
          attributions.append(node);
        }
        card.hidden = false;
      } catch { if (this.isConnected) status.textContent = this.dataset.ratingError; }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smx-manual-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smx-manual-library')) {
    customElements.define('smx-manual-library', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.search = this.querySelector('[data-manual-search]');
        this.sort = this.querySelector('[data-manual-sort]');
        this.grid = this.querySelector('[data-manual-grid]');
        this.cards = Array.from(this.querySelectorAll('[data-manual-card]'));
        this.filters = Array.from(this.querySelectorAll('[data-manual-category]'));
        this.activeCategory = 'all';
        this.listHeading = this.querySelector('[data-manual-heading]');
        this.defaultHeading = this.listHeading.textContent;
        this.normalise = (value) => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
        this.cards.forEach(card => { card.manualSearch = this.normalise(card.dataset.search); });
        const options = { signal: this.controller.signal };
        this.querySelectorAll('[data-manual-controls]').forEach(control => { control.hidden = false; });
        this.search.addEventListener('input', () => this.updateResults(), options);
        this.filters.forEach(button => button.addEventListener('click', () => {
          this.activeCategory = button.dataset.manualCategory;
          this.updateResults();
        }, options));
        this.querySelector('[data-manual-clear]').addEventListener('click', () => {
          this.search.value = '';
          this.updateResults();
          this.search.focus();
        }, options);
        this.querySelector('[data-manual-reset]').addEventListener('click', () => this.resetFilters(), options);
        if (this.sort) this.sort.addEventListener('change', () => {
          const mode = this.sort.value;
          const locale = document.documentElement.lang || 'de';
          const ordered = this.cards.slice().sort((a, b) => {
            if (mode === 'recommended') return Number(a.dataset.position) - Number(b.dataset.position);
            return a.dataset.title.localeCompare(b.dataset.title, locale, { sensitivity: 'base', numeric: true }) * (mode === 'za' ? -1 : 1);
          });
          ordered.forEach(card => this.grid.append(card));
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          this.resetFilters(false);
        }, options);
        this.updateResults();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
      }

      resetFilters(focus = true) {
        this.search.value = '';
        this.activeCategory = 'all';
        this.updateResults();
        if (focus) this.search.focus();
      }

      updateResults() {
        const words = this.normalise(this.search.value).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        this.cards.forEach(card => {
          const categoryMatch = this.activeCategory === 'all' || card.dataset.category === this.activeCategory;
          card.hidden = !categoryMatch || !words.every(word => card.manualSearch.includes(word));
          if (!card.hidden) count++;
        });
        this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.manualCategory === this.activeCategory)));
        const active = this.filters.find(button => button.dataset.manualCategory === this.activeCategory);
        this.listHeading.textContent = this.activeCategory === 'all' ? this.defaultHeading : active.querySelector('.smx-manuals__category-name').textContent;
        this.querySelector('[data-manual-clear]').hidden = this.search.value.length === 0;
        this.querySelector('[data-manual-empty]').hidden = count > 0;
        this.grid.hidden = count === 0;
        const template = count === 1 ? this.dataset.resultOne : this.dataset.resultMany;
        this.querySelector('[data-manual-status]').textContent = template.replace('__count__', String(count));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spiegelmax-announcement-bar-custom"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smx-topbar-carousel')) {
    customElements.define('smx-topbar-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        this._abort = new AbortController();
        const options = { signal: this._abort.signal };
        this._slides = Array.from(this.querySelectorAll('[data-smx-message]'));
        this._track = this.querySelector('[data-smx-messages]');
        this._pauseButton = this.querySelector('[data-smx-pause]');
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._autoplay = this.dataset.autoplay === 'true';
        this._speed = Math.max(3000, Number(this.dataset.speed) || 5000);
        this._index = Math.max(0, this._slides.findIndex(slide => slide.classList.contains('is-active')));
        this._userPaused = false;
        this._hovered = false;
        this._focused = false;
        this._editorSelected = false;
        if (!this._slides.length || !this._track) return;

        this.querySelector('[data-smx-prev]')?.addEventListener('click', () => this._manual(-1), options);
        this.querySelector('[data-smx-next]')?.addEventListener('click', () => this._manual(1), options);
        this._pauseButton?.addEventListener('click', () => {
          this._userPaused = !this._userPaused;
          this._schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this._hovered = true; this._schedule(); }, options);
        this.addEventListener('mouseleave', () => { this._hovered = false; this._schedule(); }, options);
        this.addEventListener('focusin', () => { this._focused = true; this._schedule(); }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            this._focused = this.contains(document.activeElement);
            this._schedule();
          });
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this._manual(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        document.addEventListener('visibilitychange', () => this._schedule(), options);
        this._motion.addEventListener('change', () => this._schedule(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this._slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this._editorSelected = true;
          this._show(index);
          this._schedule();
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (!this._slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this._editorSelected = false;
          this._schedule();
        }, options);
        this._show(this._index);
        this._schedule();
      }

      disconnectedCallback() {
        window.clearInterval(this._timer);
        this._abort?.abort();
        this._abort = null;
      }

      _show(index) {
        this._index = (index + this._slides.length) % this._slides.length;
        this.dataset.currentIndex = String(this._index);
        this._slides.forEach((slide, i) => {
          const active = i === this._index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
          slide.querySelectorAll('a, button').forEach(element => { element.tabIndex = active ? 0 : -1; });
        });
      }

      _manual(direction) {
        this._show(this._index + direction);
        this._schedule();
      }

      _schedule() {
        window.clearInterval(this._timer);
        const paused = this._userPaused || this._hovered || this._focused || this._editorSelected || this._motion.matches || document.visibilityState !== 'visible';
        this._track?.setAttribute('aria-live', paused ? 'polite' : 'off');
        if (this._pauseButton) {
          this._pauseButton.hidden = !this._autoplay || this._motion.matches;
          this._pauseButton.setAttribute('aria-pressed', this._userPaused ? 'true' : 'false');
          this._pauseButton.setAttribute('aria-label', this._userPaused ? this._pauseButton.dataset.playLabel : this._pauseButton.dataset.pauseLabel);
          this._pauseButton.querySelector('[data-smx-pause-icon]').hidden = this._userPaused;
          this._pauseButton.querySelector('[data-smx-play-icon]').hidden = !this._userPaused;
        }
        if (!this.isConnected || !this._autoplay || paused || this._slides.length < 2) return;
        this._timer = window.setInterval(() => this._show(this._index + 1), this._speed);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spiegelmax-halloween-bats"]) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      let delayId;
      let idleId;
      let finishId;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
      const sessionKey = root.dataset.sessionKey;

      const blocked = () => {
        return document.visibilityState !== 'visible' ||
          reducedMotion.matches ||
          document.body.classList.contains('modal-show') ||
          document.body.classList.contains('has-config-dock') ||
          new URLSearchParams(window.location.search).get('view') === 'configurator';
      };

      const cleanup = () => {
        window.clearTimeout(delayId);
        window.clearTimeout(finishId);
        if (idleId !== undefined && window.cancelIdleCallback) window.cancelIdleCallback(idleId);
        window.removeEventListener('load', queue);
        window.removeEventListener('pagehide', cleanup);
        window.removeEventListener('pointerdown', cleanup);
        window.removeEventListener('keydown', cleanup);
        root.remove();
      };

      const start = () => {
        if (!root.isConnected || blocked()) {
          cleanup();
          return;
        }

        if (!inEditor) {
          try {
            if (window.sessionStorage.getItem(sessionKey)) {
              cleanup();
              return;
            }
            window.sessionStorage.setItem(sessionKey, '1');
          } catch {
            cleanup();
            return;
          }
        }

        root.hidden = false;
        finishId = window.setTimeout(cleanup, 3600);
      };

      const queue = () => {
        delayId = window.setTimeout(() => {
          if (window.requestIdleCallback) {
            idleId = window.requestIdleCallback(start, { timeout: 1200 });
          } else {
            start();
          }
        }, 500);
      };

      if (blocked()) {
        cleanup();
        return;
      }

      window.addEventListener('pagehide', cleanup, { once: true });
      window.addEventListener('pointerdown', cleanup, { once: true, passive: true });
      window.addEventListener('keydown', cleanup, { once: true });

      if (document.readyState === 'complete') {
        queue();
      } else {
        window.addEventListener('load', queue, { once: true });
      }
    };

    document.querySelectorAll('[data-smx-halloween-bats]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-smx-halloween-bats]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
